import React, { useRef } from 'react';
import { Check } from '@phosphor-icons/react';

import { FilterOption } from '../types';

interface SingleSelectDropdownProps {
  valueOptions: FilterOption[];
  isValueSelected: (valueId: string) => boolean;
  onValueSelect: (valueId: string) => void;
}

export const SingleSelectDropdown: React.FC<SingleSelectDropdownProps> = ({
  valueOptions,
  isValueSelected,
  onValueSelect,
}) => {
  const buttonRefs = useRef<(HTMLButtonElement | null)[]>([]);

  const focusButton = (index: number) => {
    buttonRefs.current[index]?.focus();
  };

  const handleKeyDown = (e: React.KeyboardEvent, index: number) => {
    switch (e.key) {
      case 'ArrowDown': {
        e.preventDefault();
        const nextIndex = Math.min(index + 1, valueOptions.length - 1);
        focusButton(nextIndex);
        break;
      }
      case 'ArrowUp': {
        e.preventDefault();
        const prevIndex = Math.max(index - 1, 0);
        focusButton(prevIndex);
        break;
      }
      case 'Enter':
      case 'Spacebar':
        e.preventDefault();
        onValueSelect(valueOptions[index].id);
        break;
    }
  };

  return (
    <div className="py-1" role="listbox">
      {valueOptions.map((option, index) => (
        <button
          key={option.id}
          ref={(el) => (buttonRefs.current[index] = el)}
          type="button"
          className="relative flex w-full text-left cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
          onClick={() => onValueSelect(option.id)}
          onKeyDown={(e) => handleKeyDown(e, index)}
        >
          {isValueSelected(option.id) && <Check size={14} className="mr-2" />}
          {!isValueSelected(option.id) && <span className="mr-2 w-3.5" />}
          {option.label}
        </button>
      ))}
    </div>
  );
};
